import styled, { css } from 'styled-components';

import Link from 'Elements/Link';

export const List = styled.ul<{ $backgroundColor?: string }>`
    ${({ theme, $backgroundColor }) => css`
        display: inline-flex;
        margin: 0;
        padding: 0 0.25rem;
        list-style: none;
        background-color: ${$backgroundColor ? $backgroundColor : theme.colors.primaryContrast.hex};
        border-radius: 0.5rem;
    `}
`;

export const ListItem = styled.li`
    ${({ theme }) => css`
        margin: 0;
        padding: 0.5rem 0.675rem;

        @media ${theme.breakpoints.large.media} {
            padding: 0.5rem 1.25rem;
        }
    `}
`;

export const StyledLink = styled(Link)`
    ${({ theme }) => css`
        color: ${theme.colors.tertiary.hex};
        text-decoration: none;

        &:hover {
            color: ${theme.colors.primary.hex};
        }
    `}
`;
